module.exports = __webpack_public_path__ + "static/img/organism-h5-5.55f585d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/organism-h5-5.png
// module id = htt4
// module chunks = 34